<template>
  <v-card>
    <v-card-title> {{ title }}</v-card-title>
    <v-card-text>
      <v-row align="end">
        <v-col cols="12">
          <v-alert
            dense
            outlined
            border="left"
            type="warning"
            icon="mdi-alert-outline"
            v-if="packSeleccionado && isPackBloqueado"
          >
            Este pack está bloqueado por un asiento de cierre y no puede ser modificado
          </v-alert>
        </v-col>
      </v-row>
      <v-row align="end">
        <!-- CLIENTE -->
        <v-col
          cols="12"
          sm="6"
        >
          <v-autocomplete
            v-model="clienteSeleccionadoComponente"
            :items="clientes"
            v-if="isNuevoPack || !isPackBloqueado"
            chips
            :loading="loadingClientes"
            :disabled="loadingClientes || isPackBloqueado"
            color="blue-grey lighten-2"
            label="Cliente"
            return-object
            clearable
            @input="actualizarCliente"
            @blur="actualizarCliente"
            :error-messages="errorCliente"
            class="anadirAsterisco"
          >
          </v-autocomplete
          ><v-text-field
            v-else
            disabled
            v-model="clienteSeleccionadoComponente.text"
          >
          </v-text-field>
        </v-col>
        <!-- CONTRATO -->
        <v-col
          cols="12"
          sm="6"
        >
          <v-autocomplete
            v-model="contratoSeleccionadoComponente"
            :items="contratos"
            chips
            v-if="isNuevoPack || !isPackBloqueado"
            :loading="loadingContratos"
            :disabled="loadingContratos || isPackBloqueado"
            color="blue-grey lighten-2"
            label="Contrato"
            return-object
            clearable
            @input="actualizarContrato"
            @blur="actualizarContrato"
            :error-messages="errorContrato"
            class="anadirAsterisco"
          >
          </v-autocomplete>
          <v-text-field
            v-else
            disabled
            v-model="contratoSeleccionadoComponente.text"
          >
          </v-text-field>
        </v-col>
        <!-- FECHA -->
        <v-col
          cols="12"
          sm="6"
        >
          <date-picker
            v-bind:date="packSeleccionado.fechaRegistro"
            @actualizarFecha="actualizarFechaRegistro"
            v-bind:disabled="isPackBloqueado"
            v-bind:required="true"
            @fechaEditada="touchFecha"
            v-bind:errorMessage="errorFecha"
          ></date-picker>
        </v-col>
        <!-- HORAS -->
        <v-col
          cols="12"
          sm="6"
        >
          <v-text-field
            type="number"
            v-model="packSeleccionado.horasContratadas"
            label="Horas ponderadas"
            :disabled="isPackBloqueado"
            @input="$v.packSeleccionado.horasContratadas.$touch()"
            @blur="$v.packSeleccionado.horasContratadas.$touch()"
            :error-messages="errorHoras"
            class="anadirAsterisco"
          ></v-text-field>
        </v-col>
        <!-- COMENTARIO -->
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-textarea
            class="mx-2 anadirAsterisco"
            label="Comentarios"
            v-model="packSeleccionado.observaciones"
            no-resize
            :disabled="isPackBloqueado"
            @input="$v.packSeleccionado.observaciones.$touch()"
            @blur="$v.packSeleccionado.observaciones.$touch()"
            :error-messages="errorComentario"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-btn
        v-if="!isNuevoPack"
        color="error"
        text
        @click="dialogEliminar = true"
        :disabled="packSeleccionado && isPackBloqueado"
        >Eliminar</v-btn
      >
      <v-spacer></v-spacer>
      <v-btn
        color="error"
        text
        @click="cerrarDialogPacks"
        >Cancelar</v-btn
      >
      <v-btn
        text
        @click="aceptarPack()"
        :disabled="(packSeleccionado && isPackBloqueado) || $v.$invalid"
      >
        Aceptar
      </v-btn>
    </v-card-actions>
    <v-dialog
      v-model="dialogEliminar"
      persistent
      max-width="380"
    >
      <v-card>
        <v-card-title class="headline">¡Atención!</v-card-title>
        <v-card-text>Vas a eliminar este pack. ¿Estás seguro?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="dialogEliminar = false"
            >Cancelar</v-btn
          >
          <v-btn
            color="error"
            text
            @click="eliminarPack"
            >Eliminar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
  import PackHoras from './pack'
  import Datepicker from '../../components/utils/Datepicker'
  import axios from 'axios'

  import { mapActions } from 'vuex'
  import { required } from 'vuelidate/lib/validators'

  axios.defaults.withCredentials = true
  axios.defaults.baseURL = process.env.VUE_APP_API_URL

  const disintoDeCero = value => value != 0

  export default {
    components: {
      'date-picker': Datepicker,
    },
    props: ['title', 'pack'],
    data() {
      return {
        packSeleccionado: null,
        clienteSeleccionadoComponente: [],
        contratoSeleccionadoComponente: [],
        dialogEliminar: false,
      }
    },
    validations: {
      packSeleccionado: {
        fechaRegistro: { required },
        horasContratadas: { required, disintoDeCero },
        observaciones: { required },
      },
      clienteSeleccionadoComponente: {
        text: { required },
      },
      contratoSeleccionadoComponente: {
        text: { required },
      },
    },
    methods: {
      ...mapActions(['setSnackbar']),
      cerrarDialogPacks() {
        this.$nextTick(() => {
          this.$v.$reset()
        })
        this.$emit('cerrarDialogPacks')
      },
      actualizarFechaRegistro(val) {
        this.packSeleccionado.setFecha(val)
      },
      touchFecha() {
        this.$v.packSeleccionado.fechaRegistro.$touch()
      },
      aceptarPack() {
        if (this.$v.$anyDirty) {
          if (this.isNuevoPack) {
            this.crearPack()
          } else {
            this.actualizarPack()
          }
        }
        this.cerrarDialogPacks()
      },
      actualizarPack() {
        axios
          .patch(`api/diariohoras/${this.packSeleccionado.getId()}`, this.packSeleccionado.getObject())
          .then(res => {
            this.$emit('actualizarPack', this.packSeleccionado.getPack())
            this.setSnackbar({
              tipo: 'success',
              mensaje: 'Pack actualizado correctamente',
            })
          })
          .catch(err => {
            this.setSnackbar({
              tipo: 'error',
              mensaje: 'Error. No se ha podido guardar el pack',
            })
          })
      },
      crearPack() {
        axios
          .post(`api/diariohoras`, this.packSeleccionado.getObject())
          .then(res => {
            this.packSeleccionado.setId(res.data)
            this.$emit('insertarPack', this.packSeleccionado.getPack())
            this.setSnackbar({
              tipo: 'success',
              mensaje: 'Pack guardado correctamente',
            })
            this.packSeleccionado = new PackHoras(null)
            this.clienteSeleccionadoComponente = []
            this.contratoSeleccionadoComponente = []
          })
          .catch(err => {
            this.setSnackbar({
              tipo: 'error',
              mensaje: 'Error. No se ha podido guardar el pack',
            })
          })
      },
      eliminarPack() {
        this.dialogEliminar = false
        axios
          .delete(`api/diariohoras/${this.packSeleccionado.getId()}`)
          .then(res => {
            this.$emit('eliminarPack', this.packSeleccionado.getPack())
            this.setSnackbar({
              tipo: 'success',
              mensaje: 'Pack eliminado correctamente',
            })
          })
          .catch(err => {
            this.setSnackbar({
              tipo: 'error',
              mensaje: 'Error. No se ha eliminar el pack',
            })
          })
        this.cerrarDialogPacks()
      },
      actualizarContrato() {
        this.$v.contratoSeleccionadoComponente.text.$touch()
        this.packSeleccionado.setContrato(this.contratoSeleccionadoComponente)
      },
      actualizarCliente() {
        this.$v.clienteSeleccionadoComponente.text.$touch()
        this.packSeleccionado.setCliente(this.clienteSeleccionadoComponente)
      },
    },
    computed: {
      isPackBloqueado() {
        return this.packSeleccionado.fechaCierre != null
      },
      isNuevoPack() {
        return this.packSeleccionado.esNuevoPack()
      },
      contratos() {
        return this.$store.getters['contratos/contratosDisponibles']
      },
      loadingContratos() {
        return this.$store.getters['contratos/loadingContratos']
      },
      loadingClientes() {
        return this.$store.getters.loadingClientes
      },
      clientes() {
        return this.$store.getters.clientesDisponibles
      },
      errorHoras() {
        return this.$v.packSeleccionado.horasContratadas.$dirty && this.$v.packSeleccionado.horasContratadas.$invalid
          ? 'Introduce las horas'
          : null
      },
      errorComentario() {
        return this.$v.packSeleccionado.observaciones.$dirty && this.$v.packSeleccionado.observaciones.$invalid
          ? 'Introduce el comentario'
          : null
      },
      errorFecha() {
        return this.$v.packSeleccionado.fechaRegistro.$dirty && this.$v.packSeleccionado.fechaRegistro.$invalid
          ? 'Introduce la fecha'
          : null
      },
      errorCliente() {
        return this.$v.clienteSeleccionadoComponente.text.$dirty && this.$v.clienteSeleccionadoComponente.text.$invalid
          ? 'Selecciona el cliente'
          : null
      },
      errorContrato() {
        return this.$v.contratoSeleccionadoComponente.text.$dirty &&
          this.$v.contratoSeleccionadoComponente.text.$invalid
          ? 'Selecciona el contrato'
          : null
      },
    },
    created() {
      this.packSeleccionado = new PackHoras(this.pack)
      this.clienteSeleccionadoComponente = this.packSeleccionado.getCliente()
      this.contratoSeleccionadoComponente = this.packSeleccionado.getContrato()
      if (!this.contratos.length) {
        this.$store.dispatch('contratos/getContratosDisponibles', 1)
      }

      if (!this.$store.getters.clientesDisponibles.length) {
        this.$store.dispatch('getClientesDisponibles')
      }
    },
  }
</script>
